module.exports = __webpack_public_path__ + "img/addIcon.44e0d789.svg";